module.exports = __webpack_public_path__ + "img/44690acbc035b6f919b1016aa4e763a4.png";